import { render, staticRenderFns } from "./PreloaderWithTextSlides.vue?vue&type=template&id=39bc3413&scoped=true"
import script from "./PreloaderWithTextSlides.vue?vue&type=script&lang=js"
export * from "./PreloaderWithTextSlides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc3413",
  null
  
)

export default component.exports